import styled from 'styled-components'

export const ResetButton  = styled.button`
    background: none;
    border: none;
    padding: 0;
    font-size: 1em;
    /*optional*/
    font-family: arial, sans-serif;
    /*input has OS specific font-family*/
    color: #069;
    text-decoration: underline;
    cursor: pointer;
`